import { useState, useEffect } from 'react';
import './style.css';
import { getAllProducts } from '../../../usecases/products-usecase';
import MultiSearchDropdown from '../../atoms/multiSearchDropdown/view';
import { userSingleton } from '../../../app/classes/User';

/**
 * MultiProductSearchDropdown
 * Molecule to select multiple products for reports.
 * Uses Atomic multiSearchDropdown atom.
 */
const MultiProductSearchDropdown = ({ onSelected, selected = [], uid, cid }) => {
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchProducts = async () => {
        try {
            setLoading(true);
            const userUid = uid || userSingleton.uid;
            const userCid = cid || userSingleton.cid || userUid;

            console.log("Fetching products with:", { userUid, userCid });

            // Fetch first 200 products as initial set
            const response = await getAllProducts("", "", '', 1, 100, false, true);
            console.log("getAllProducts response:", response);

            // Based on ProductsTable, the array is in response.data
            const results = response.data || (Array.isArray(response) ? response : []);

            console.log("Processed results:", results);

            setAllProducts(results.map(p => ({
                ...p,
                displayName: `${p.sku || ''} - ${p.name || ''}`
            })));
        } catch (err) {
            console.error("Error loading products for dropdown:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [uid, cid]);

    if (loading) return <div className="p-2 small text-muted">Cargando productos...</div>;

    return (
        <div className="multi-product-selector-wrapper w-100">
            <label className="form-label small fw-bold text-secondary mb-1">
                Filtrar por Productos (Opcional)
            </label>
            <MultiSearchDropdown
                placeholder="Escribe para buscar productos..."
                options={allProducts}
                path="displayName"
                onSelected={onSelected}
                selected={selected}
            />
            <div className="form-text x-small text-muted mt-1">
                Si no seleccionas ninguno, se mostrarán todos los productos.
            </div>
        </div>
    );
};

export default MultiProductSearchDropdown;
